import CircularProgress from '@mui/material/CircularProgress';

interface GovernanceTabLoadingStateProps {
  label?: string;
}

const GovernanceTabLoadingState = ({ label = 'Loading governance analysis...' }: GovernanceTabLoadingStateProps) => (
  <div className="d-flex justify-content-center align-items-center py-5" role="status" aria-live="polite">
    <CircularProgress size={28} />
    <span className="ms-3 text-muted">{label}</span>
  </div>
);

export default GovernanceTabLoadingState;
